import {StyleParamType, createStylesParams} from '@wix/tpa-settings';

export enum CartWidgetParamNames {
  CART_WIDGET_CART_ICON_TEXT = 'cartWidget_cartIconText',
  CART_WIDGET_CART_ICON_TEXT_FONT = 'cartWidget_cartIconTextFont',
  CART_WIDGET_CART_ICON_NUMBER = 'cartWidget_cartIconNumber',
  CART_WIDGET_CART_ICON_NUMBER_FONT = 'cartWidget_cartIconNumberFont',
  CART_WIDGET_CART_ICON_BUBBLE = 'cartWidget_cartIconBubble',
  CART_WIDGET_CART_ICON = 'cartWidget_cartIcon',
}

export type IStylesParams = {
  cartIconTextFont: StyleParamType.Font;
  cartIconTextColor: StyleParamType.Color;
  cartIconBubbleColor: StyleParamType.Color;
  cartIconColor: StyleParamType.Color;
  cartIconNumberFont: StyleParamType.Font;
  cartIconNumberColor: StyleParamType.Color;
};

export default createStylesParams<IStylesParams>({
  cartIconBubbleColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_BUBBLE,
  },
  cartIconColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON,
  },
  cartIconTextFont: {
    type: StyleParamType.Font,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_TEXT_FONT,
  },
  cartIconTextColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_TEXT,
  },
  cartIconNumberFont: {
    type: StyleParamType.Font,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_NUMBER_FONT,
  },
  cartIconNumberColor: {
    type: StyleParamType.Color,
    key: CartWidgetParamNames.CART_WIDGET_CART_ICON_NUMBER,
  },
});
